var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBusTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 12h-2v2h2v-2z",
    fill: "#54822B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 26.5h-.4c-.4-1.5-1.8-2.5-3.4-2.5-1.6 0-2.9 1.1-3.4 2.5h-3.7c-.4-1.5-1.8-2.5-3.4-2.5-1.6 0-2.9 1.1-3.4 2.5h-1.3v-3.2h19v3.2zM25.7 29c-.5 0-.9-.2-1.1-.5-.2-.3-.4-.6-.4-1s.1-.7.4-1c.3-.3.7-.5 1.1-.5.5 0 .9.2 1.1.5.2.3.4.6.4 1s-.1.7-.4 1c-.2.3-.6.5-1.1.5zm-11.6-.5c-.2-.3-.4-.6-.4-1s.1-.7.4-1c.3-.3.7-.5 1.1-.5.5 0 .9.2 1.1.5.2.3.4.6.4 1s-.1.7-.4 1c-.3.3-.7.5-1.1.5-.4 0-.8-.2-1.1-.5zm-1.4-10.7h2.8v2h2v-2h3v2h2v-2h3.1v2h2v-2h1.9v3.4H11l1.7-3.4zm17.8-2H12c-.4 0-.8.3-.9.6l-2.5 5.4c-.1.2-.1.3-.1.4v5.2c0 .6.4 1 1 1h2.4c.4 1.5 1.8 2.5 3.4 2.5 1.6 0 2.9-1.1 3.4-2.5h3.7c.4 1.5 1.8 2.5 3.4 2.5 1.6 0 2.9-1.1 3.4-2.5h1.3c.6 0 1-.4 1-1V16.8c0-.6-.4-1-1-1z",
    fill: "#54822B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 5h-2v4h2V5z",
    fill: "#54822B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18V3h20v3.2c-3.6 1.2-3.6 6.4 0 7.6h2V12h-.8c-.2 0-.4 0-.5-.1-1.9-.6-1.9-3.3 0-3.8.2-.1.4-.1.6-.1h.7V3c0-1.1-.9-2-2-2h-20c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h3.9l.9-2H3.5z",
    fill: "#54822B"
  })));
}

export default SvgIconBusTicket;